import { ApiUser, ROLE_ADMIN } from './getUser'

type AffiliateUser = Pick<ApiUser, 'affiliate_user_id' | 'role_id'>;

export function mustHaveMFA(user: AffiliateUser) {
    return user.affiliate_user_id !== undefined && Number(user.role_id) === ROLE_ADMIN
}
